import React, { useEffect, useState } from "react";
import { api, fmtMoney } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { toast } from "sonner";

export default function CashbackApprovals() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("pending");

  const load = async (t) => {
    const { data } = await api.get(`/admin/cashback-approvals?status=${t}`);
    setItems(data);
  };

  useEffect(() => { load(tab); }, [tab]);

  const approve = async (id) => {
    try {
      await api.post(`/admin/cashback/${id}/approve`);
      toast.success("Cashback approved");
      load(tab);
    } catch (e) {
      toast.error("Couldn't approve");
    }
  };

  return (
    <div data-testid="adm-cashback-page">
      <PageHeader eyebrow="Approvals" title="Cashback transactions" subtitle="Review and approve pending cashback after merchant confirmation." />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="pending">Pending</TabsTrigger>
          <TabsTrigger value="approved">Approved</TabsTrigger>
          <TabsTrigger value="all">All</TabsTrigger>
        </TabsList>
        <TabsContent value={tab}>
          <Card className="border-gray-200 shadow-none rounded-2xl">
            <CardContent className="p-0">
              <table className="w-full text-sm">
                <thead className="border-b border-gray-200 bg-gray-50">
                  <tr className="text-left">
                    <th className="px-5 py-3 font-semibold">Merchant</th>
                    <th className="px-5 py-3 font-semibold">Order</th>
                    <th className="px-5 py-3 font-semibold">Cashback</th>
                    <th className="px-5 py-3 font-semibold">Status</th>
                    <th className="px-5 py-3 font-semibold">Date</th>
                    <th className="px-5 py-3 font-semibold w-32">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((t) => (
                    <tr key={t.id} className="border-b border-gray-100">
                      <td className="px-5 py-3 font-medium">{t.merchant_name}</td>
                      <td className="px-5 py-3">{fmtMoney(t.order_amount)}</td>
                      <td className="px-5 py-3 text-emerald-700 font-semibold">{fmtMoney(t.cashback)}</td>
                      <td className="px-5 py-3"><Badge variant="outline">{t.status}</Badge></td>
                      <td className="px-5 py-3 text-gray-500">{new Date(t.created_at).toLocaleDateString()}</td>
                      <td className="px-5 py-3">
                        {t.status !== "approved" && (
                          <Button size="sm" onClick={() => approve(t.id)} className="bg-emerald-700 hover:bg-emerald-800 text-white">Approve</Button>
                        )}
                      </td>
                    </tr>
                  ))}
                  {items.length === 0 && <tr><td colSpan="6" className="px-5 py-12 text-center text-gray-500">No transactions in this view.</td></tr>}
                </tbody>
              </table>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
